import { tns } from 'tiny-slider/src/tiny-slider';

class StatsSlider {
	constructor(el, nav) {
		this.el = el;
		this.nav = nav;

		const statsSlider = tns({
			container: this.el,
			items: 1,
			slideBy: 1,
			mode: "gallery",
			autoplay: false,
			autoplayButtonOutput: false,
			speed: 400,
			controls: false,
			nav: true,
			navPosition: "bottom",
			navContainer: this.nav
		});
		return statsSlider;
	}
}

export default StatsSlider;